var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.project.is_demo)?_c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$router.push({ name: 'account.billing', query: { feature: _vm.feature } })}}},[_c('span',[_c('i',{staticClass:"fas fa-rocket mr-5"}),_vm._v(_vm._s(_vm.$t('labels.upgrade')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }